import React from "react";
import {
	View, Text, StyleSheet, TouchableOpacity, ActivityIndicator, I18nManager as RNI18nManager,
	Platform, Dimensions, I18nManager, AsyncStorage
} from "react-native";

import * as firebase from "firebase";
import store from "../config/config.json"
import { color } from "../config/color"
import i18n from 'i18n-js';
import { translations } from '../config/translations';

//const RCTNetworking = require('react-native/Libraries/Network/RCTNetworking')

export default class SplashScreen extends React.Component {

	static path = ""
	state = {
		store: {},
	};

	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		let screenWidth = window.innerWidth;
		let screenHeight = window.innerHeight;

		this.state.height = screenHeight
		this.state.width = screenWidth

		//RCTNetworking.clearCookies(() => { })
		console.log(window.location.href)

		if (screenWidth < color.screenLimit) {
			this.state.showFullMode = false;
		} else {
			this.state.showFullMode = true;
		}

		if (Platform.OS === 'ios')
			this.state.showFullMode = false;
	}

	componentDidMount() {

		try {
			Dimensions.addEventListener('change', (e) => {
				const { width, height } = e.window;
				this.setState({ height: height, width: width })
				if (width < color.screenLimit) {
					this.setState({ showFullMode: false });
				} else {
					this.setState({ showFullMode: true });
				}
			})

			this.getDetails()
		} catch { }
	}

	getDetails = async () => {

		// Set the key-value pairs for the different languages you want to support.
		var that = this
		firebase.database().ref('stores/' + store.storeId).once("value", function (snapshot) {

			const data = snapshot.val();
			console.log(data);
			if (data != undefined) {
				that.saveData(data)
			}
			else {
				that.setState({ showLoading: false })
			}

		}.bind(this), function (error) {
			console.log(error)
		});
	}

	saveData = async data => {

		if (data.defaultLanguage == 'ar') {
			RNI18nManager.forceRTL(true);
			// RN won't set the layout direction if we
			// don't restart the app's JavaScript.
			//Updates.reloadFromCache();
		}

		i18n.translations = translations;
		// Set the locale once at the beginning of your app.
		i18n.locale = data.defaultLanguage;
		await AsyncStorage.setItem(store.storeData, JSON.stringify(data))
		this.setState({ showLoading: false })

		var params = this.props.navigation.state.params
		if (params !== undefined) {
			let action = params.action
			if (action != undefined) {
				params = JSON.stringify(params)
				params = params.replace('"action":"' + action + '",', "")
				this.props.navigation.navigate(action, JSON.parse(params));
			}
			else {
				if (params == "search")
					this.props.navigation.navigate("search")
				else
					this.props.navigation.navigate("menu")
			}
		}
		else
			this.props.navigation.navigate("menu")
	};

	render() {

		return (
			<View style={{ flex: 1, justifyContent: "center", alignItems: "center", alignItems: "center" }}>
				<ActivityIndicator size="small" color={store.primaryColor} />
			</View>
		);
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.bigSeparator
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
		position: "absolute",
		width: "100%",
		height: 50,
		flexDirection: "row",
		alignContent: "center",
		alignItems: "center"
	}
});